import * as THREE from 'three';

import fragmentShader from './shine.frag';
import vertexShader from './shine.vert';

class ShineLayer extends THREE.Mesh {
    constructor(settings = {}) {
        // Create background quad with shine shader
        const uniforms = {
            uTime: { value: 0 },
            uAspect: { value: window.innerWidth / window.innerHeight },
            uLightPosition: { value: new THREE.Vector2(0.5, 0.5) },
            uLightIntensity: { value: 1.0 },
            // uRayCount: { value: 12.0 },
            uRaySpeed: { value: 0.8 },
            uLargeVariation: { value: 1.0 },
            lightColor: { value: new THREE.Color(1.0, 0.9, 0.7) },
            uGammaBorder: { value: 1.0 },
            uUVScale: { value: new THREE.Vector2(1.6, 1.1) },
        };
        for (let key in settings) {
            uniforms[key].value = settings[key];
        }
        const bgGeometry = new THREE.PlaneGeometry(3, 3);
        const bgMaterial = new THREE.ShaderMaterial({
            vertexShader,
            fragmentShader,
            uniforms,
            depthWrite: false,
            // depthTest: false,
            blending: THREE.AdditiveBlending,
        });

        super(bgGeometry, bgMaterial);
        this.position.z = -1;
        this.renderOrder = -1;
        this.name = 'ShineLayer';
    }

    animate(timeOffset = 0) {
        this.material.uniforms.uTime.value = performance.now() * 0.001 + timeOffset;
    }
}

export default ShineLayer;
